// extracted by mini-css-extract-plugin
export default {"buttonClass":"MisReports_buttonClass__gADgI","buttonClass--matches":"MisReports_buttonClass--matches__zpqF0","boxButtonStyle":"MisReports_boxButtonStyle__yMTen"};